import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel"
import { IRazonEdit } from "../../../../../Interfaces/auxiliar/IRazon"
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { UsePanelRazonEliminar } from "./usePanelRazonEliminar";
import { Panel } from "@fluentui/react";
import { ProgressBarLoading } from "../../../../../components/ProgressBarLoading/ProgressBarLoading";
import { MessageBarResponse } from "../../../../../components/MessageBarResponse/MessageBarResponse";
import { PanelHeaderBasic } from "../../../../../components/Panel/PanrlHeaderBasic";
import { Body1, makeStyles } from "@fluentui/react-components";
import { Warning24Filled } from "@fluentui/react-icons";

export interface IPanelRazonEliminar extends IOpenPanel{
    item: IRazonEdit
}
export const PanelRazonEliminar=(props:IPanelRazonEliminar)=>{
  const styles = useStyles();
    const {request,setRequest,deleteRazon,loading,reset,mensaje,status,contentShow, loadprogress} = UsePanelRazonEliminar(props)
    const onRenderHeader = useCallback(
      () => (
          <PanelHeaderBasic
            subTextHeader=""
            textHeader="Eliminar Razón"
          />
      ),
      []
  );
   
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Eliminar"
              texto2={"Salir"}
              //disableButton={disableForm}
              onClick={deleteRazon}
              onDismiss={() => {
                 reset()
              }}
            />
          </>
        ),
        [request]
      );
      return (
        <Panel 
        isOpen={props.isOpen}
        onDismiss={reset}
        onRenderHeader={onRenderHeader}
        isFooterAtBottom
        onRenderFooter={onRenderFooter}
        >
        <div hidden={mensaje == ""}>
        <MessageBarResponse
          objetoResponse={{ codigo: status, mensaje: mensaje }}
          close={true}
        />
        </div>
        <div hidden={!loading}>
        <ProgressBarLoading></ProgressBarLoading>
       </div>
       <div hidden={loading}>
        {!mensaje && (
          <>
            {!loadprogress && (
              <>
                {contentShow && (
                  <>
                    <div className={styles.container}>
                      <div>
                        <Warning24Filled className={styles.warning} />
                      </div>
                      <div>
                        <Body1>
                          Esta Razón será eliminada permanentemente, ¿Desea
                          eliminar la Razón: {props.item.codigo}?
                        </Body1>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
       </Panel>
      )
}
const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    top: "100%",
    alignItems: "center",
  },

  warning: {
    color: " #eaa300",
    width: "60px",
    height: "60px",
  },
});